import React, { useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import './acadassoc.css';
import articleContext from './articlecontext';

const AcadassocPageeee = () => {
  const [artdata, setArtdata] = useContext(articleContext);
  const location = useLocation();
  const year = location.state?.year || 2025;

  useEffect(() => {
    if (!artdata || artdata.length === 0) {
      axios.get('https://dojma-website-2pip.onrender.com/data')
        .then(res => setArtdata(res.data.slice().reverse()))
        .catch(err => console.error(err));
    }
  }, []);

  if (!artdata || artdata.length === 0) return <div className="acads-container">Loading...</div>;

  return (
    <div className='bigg'><div className='thebig4'>
      <Link to={"/acadassoc_cs"} state={{ year }} className='big4text'>
        CS
      </Link>
      <Link to={"/acadassoc_ece"} state={{ year }} className='big4text'>
        ECE
      </Link >
      <Link to={"/acadassoc_eni"} state={{ year }} className='big4text'>
        ENI
      </Link>
      <Link to={"/acadassoc_eee"} state={{ year }} className='big4text'>
        EEE
      </Link>
    </div><div className="acads-container">

        {/* --- PRESIDENTS SECTION --- */}
        {artdata
          .filter((item) => item.opinion?.toLowerCase() === "acadassoc" && item.position?.toLowerCase() === "pres" && item.subject?.toLowerCase() == "eee")
          .map((item, index) => (
            <div className="candidate-card" key={`prez-${index}`}>
              {item.image && (
                <div className="candidate-image-container">
                  <img className="candidate-img" src={item.image} alt={item.name} />
                </div>
              )}
              <div className="candidate-details">
                <h2 className="candidate-name">{item.candidatename?.toUpperCase()}</h2>
                <h3 className="candidate-position">PRESIDENT</h3>
                <p className="candidate-body">{item.body}</p>
              </div>
            </div>
          ))}

        <hr className="section-divider" />

        {/* --- SECRETARIES SECTION --- */}
        {artdata
          .filter((item) => item.opinion?.toLowerCase() === "acadassoc" && item.position?.toLowerCase() === "sec" && item.subject?.toLowerCase() == "eee")
          .map((item, index) => (
            <div className="candidate-card" key={`sec-${index}`}>
              {item.image && (
                <div className="candidate-image-container">
                  <img className="candidate-img" src={item.image} alt={item.name} />
                </div>
              )}
              <div className="candidate-details">
                <h2 className="candidate-name">{item.candidatename?.toUpperCase()}</h2>
                <h3 className="candidate-position">SECRETARY</h3>
                <p className="candidate-body">{item.body}</p>
              </div>
            </div>
          ))}

      </div></div>

  );
};

export default AcadassocPageeee;
